import { useEffect, useState } from "react";
import LoadingComponent from "../components/LoadingComponent";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { fetchCategories } from "../store/actions/categoryActions";
import { useDispatch, useSelector } from "react-redux";
import {
	editDetailPost,
	fetchDetailPost,
	loadingSet as loadingSetPost,
} from "../store/actions/postActions";
import { loadingSet as loadingSetCategory } from "../store/actions/categoryActions";
import Swal from "sweetalert2";

export default function EditPostPage() {
	const params = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [error, setError] = useState(false);
	const { categories, loading: loadingCategory } = useSelector((state) => state.categories);
	const { loading: loadingPost } = useSelector((state) => state.posts);
	const [editedPost, setEditedPost] = useState({
		title: "",
		slug: "",
		content: "",
		imgUrl: "",
		categoryId: "",
		authorId: "",
	});

	useEffect(() => {
		dispatch(fetchCategories())
			.catch((err) => {
				setError(true);
			})
			.finally(() => {
				dispatch(loadingSetCategory(false));
			});
	}, []);

	useEffect(() => {
		dispatch(fetchDetailPost(params.postId))
			.then((post) => {
				setEditedPost({
					title: post.title,
					slug: post.slug,
					content: post.content,
					imgUrl: post.imgUrl,
					categoryId: post.categoryId,
					authorId: post.authorId,
				});
			})
			.catch(() => {
				setError(true);
			})
			.finally(() => {
				dispatch(loadingSetPost(false));
			});
	}, []);

	const changeInputNewPost = (e) => {
		const { name, value } = e.target;
		setEditedPost({
			...editedPost,
			[name]: value,
		});
	};

	const submitHandler = (e) => {
		e.preventDefault();

		dispatch(editDetailPost(params.postId, editedPost))
			.then(() => {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "successfully edited post",
					showConfirmButton: false,
					timer: 1000,
				});
				dispatch(loadingSetPost(false));
				navigate("/");
			})
			.catch((err) => {
				return Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSetPost(false));
			});
	};

	return (
		<>
			{loadingPost ? (
				<LoadingComponent />
			) : (
				<div className="container">
					<h2 className="mb-3">Edit News</h2>
					<form onSubmit={submitHandler}>
						<div className="mb-3">
							<label className="form-label">Title</label>
							<input
								type="text"
								name="title"
								className="form-control"
								value={editedPost.title}
								onChange={changeInputNewPost}
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Content</label>
							<textarea
								type="text"
								name="content"
								className="form-control"
								value={editedPost.content}
								onChange={changeInputNewPost}
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Image Url</label>
							<input
								type="text"
								name="imgUrl"
								className="form-control"
								value={editedPost.imgUrl}
								onChange={changeInputNewPost}
							/>
						</div>
						<div className="mb-3">
							<label className="form-label">Category</label>
							<select
								name="categoryId"
								value={editedPost.categoryId}
								onChange={changeInputNewPost}
								className="form-select">
								<option value={""} disabled>
									Select category
								</option>
								{error && <h3>error</h3>}
								{!loadingCategory &&
									!error &&
									categories.map((category) => (
										<option value={category.id} key={category.id}>
											{category.name}
										</option>
									))}
							</select>
						</div>
						<div>
							<button type="submit" className="btn btn-primary">
								Share
							</button>
						</div>
					</form>
				</div>
			)}
		</>
	);
}
